<template>
  <Modal
    :width="623"
    :visible="previewVisible"
    title="AI创作"
    cancelText="重新生成"
    okText="插入文章"
    @cancel="previewVisible = false"
  >
    <div class="model-content create">
      <el-form layout="vertical" :labelCol="{ span: 5, offset: 0 }">
        <el-form-item label="输入提示词" >
          <el-input type="textarea" v-model="content" placeholder="请输入" :rows="4" />
        </el-form-item>
        <div class="x-center" style="margin-top: 10px" v-if="loading">
          <Spin />
        </div>
        <el-form-item label="生成结果" v-if="new_content">
         <el-input type="textarea" v-model="new_content" placeholder="请输入" :rows="4" />
        </el-form-item>
      </el-form>
    </div>
    <template slot="footer">
      <div class="x-end">
        <Button class="button none" v-if="new_content" :loading="loading" @click="onGeneration"
          >重新生成</Button
        >
        <Button class="button" type="primary" v-if="new_content && !loading" @click="onInsertion"
          >插入文章</Button
        >
        <Button class="button" type="primary" v-else :loading="loading" @click="onGeneration"
          >生成</Button
        >
      </div>
      <!-- <div class="x-end">
        <div class="tips"
          ><span style="color: #f53131">*</span>消耗{{ imagineNum.ai_word }}想象栗，当前剩余{{
            imagineNum.imagine_num
          }}想象栗</div
        >
      </div> -->
    </template>
  </Modal>
</template>

<script>
  import {
    Modal,
    Form,
    Textarea,
    Button,
    Spin,
    Cascader,
    Input,
    Select,
    message,
  } from 'ant-design-vue';
  import defHttp from '@/jslibs/axios/http';
  // import { useGlobSetting } from '/@/hooks/setting';

  export default {
    name: 'AICreation',
    components: {
      Modal,
      Form,
      Textarea,
      Button,
      Spin,
      Cascader,
      Input,
      Select,
    },
    data() {
      return {
        imagineNum: {},
        previewVisible: false,
        loading: false,
        dataList: [],
        dataIndex: 0,
        unfold1: false,
        paramsIndex: 0,
        content: '',
        new_content: '',
        modelData: {
          modelList: [],
          modelIndex: 0,
          isOpen: false,
        },
        classList: [],
        classDataList: [],
        details: {},
      };
    },
    methods: {
      getGptModelList() {
        return defHttp
          .get({
            url: `/v1/cms/GptModelList`,
          })
          .then((res) => {
            this.modelData.modelList = res.result;
          });
      },
      onLoadClassData(selectedOptions) {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        console.log(targetOption);
        targetOption.loading = true;
        if (targetOption.level === 2) {
          defHttp
            .get({
              url: `/v1/cms/Aiapplication`,
              params: {
                sub_class_uuid: targetOption.value,
                class_uuid: this.classList[0],
              },
            })
            .then((res) => {
              targetOption.loading = false;
              const children = [];
              res.result.data.map((item) => {
                if (item.is_system === 1) {
                  children.push({
                    label: item.name,
                    value: item.uuid,
                    isLeaf: true,
                  });
                }
              });
              targetOption.children = children;
              this.classDataList = [...this.classDataList];
            });
        } else {
          defHttp
            .get({
              url: `/v1/cms/AiapplicationClass`,
              params: {
                type: 2,
                f_uuid: targetOption.value,
              },
            })
            .then((res) => {
              targetOption.loading = false;
              const children = [];
              res.result.data.map((item) => {
                children.push({
                  label: item.name,
                  value: item.uuid,
                  isLeaf: false,
                  level: 2,
                });
              });
              targetOption.children = children;
              this.classDataList = [...this.classDataList];
            });
        }
      },
      getApplicationClass() {
        defHttp
          .get({
            url: `/v1/cms/AiapplicationClass`,
            params: {
              type: 1,
            },
          })
          .then((res) => {
            const children = [];
            res.result.data.map((item) => {
              children.push({
                label: item.name,
                value: item.uuid,
                isLeaf: false,
              });
            });
            this.classDataList = children;
          });
      },
      getDetails(id) {
        defHttp
          .get({
            url: `/v1/cms/AiApplication/${id}`,
          })
          .then((res) => {
            res.result.module_item.map((item) => {
              item.txt = '';
              if (item.type === 3) {
                item.txt = null;
              }
              if (item.type === 4) {
                item.txt = [];
              }

              let options = [];
              if (item.content.trim()) {
                options = item.content.split('\n').map((m) => {
                  return {
                    label: m,
                    value: m,
                  };
                });
              }
              item.options = options;
            });
            this.details = res.result;
          });
      },
      onClassChange(val = []) {
        this.classList = val;
        if (val.length === 3) {
          this.getDetails(val[2]);
        } else {
          this.details = {};
        }
        console.log(this.details);
      },
      onChecked(index, index1) {
        const options = this.details.module_item[index].options;
        const type = this.details.module_item[index].type;
        if (type === 4) {
          const checked = options[index1].checked;
          this.details.module_item[index].options[index1].checked = !checked;
          const array = [];
          this.details.module_item[index].options.map((item) => {
            if (item.checked) {
              array.push(item.value);
            }
          });
          this.details.module_item[index].txt = array;
        } else if (type === 3) {
          options.map((item) => {
            item.checked = false;
          });
          const checked = options[index1].checked;
          this.details.module_item[index].options[index1].checked = !checked;
          this.details.module_item[index].options.map((item) => {
            if (item.checked) {
              this.details.module_item[index].txt = item.value;
            }
          });
        }
      },
      getList() {
        defHttp.get({ url: `/v1/cms/DataSet` }).then((res) => {
          res.result.recommend_item.map((item) => (item.type = 0));
          res.result.my_item.map((item) => (item.type = 1));
          this.dataList = [
            { uuid: '', name: '通用', type: 0 },
            ...res.result.recommend_item,
            ...res.result.my_item,
          ];
        });
      },
      onGeneration() {
        if (this.loading) return false;
        let module_item = [];
        let text = '';
        
        if (!this.content) return message.warning(`请输入提示词`);
        this.loading = true;
        defHttp
          .post(`/cms/AiContent/content`, {
              content: this.content,
            })
          .then((res) => {
            this.loading = false;
            this.new_content = res.data.result;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      onInsertion() {
        this.$emit('onAiCreation', this.new_content);
        this.previewVisible = false;
      },
      onShow() {
        this.previewVisible = true;
        // this.getGptModelList();
        // this.classList = [];
        // this.details = {};
        // this.getList();
        // this.getImagineNum();
        // this.getApplicationClass();
      },
      getImagineNum() {
        defHttp
          .get({
            url: `/v1/cms/GetImagineNum`,
          })
          .then((res) => {
            this.imagineNum = res.result;
          });
      },
    },
  };
</script>

<style lang="less" scoped>
  .model-content {
    padding: 24px;
  }

  .create {
    :deep(.ant-form-item) {
      margin-bottom: 15px;
    }

    .data-item {
      min-width: 90px;
      height: 32px;
      margin-right: 12px;
      margin-bottom: 12px;
      padding: 0 10px;
      border-radius: 3px;
      background: #f6f6f6;
      color: #000;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      cursor: pointer;

      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }

      &.active {
        background: rgb(116 114 246 / 10%);
        color: #7472f6;
      }
    }

    .packup {
      height: 42px;
      overflow: hidden;
    }

    .create-data-block {
      position: relative;

      .unfold-block {
        position: absolute;
        top: 4px;
        right: 20px;
        cursor: pointer;

        .image {
          width: 12px;
          height: 12px;
        }
      }

      .avatar {
        width: 20px;
        height: 20px;
        border: 1px solid #e3e3e3;
        border-radius: 50%;
      }
    }
  }

  .tips {
    margin-top: 10px;
    color: #999;
    font-size: 12px;
    font-weight: 400;
  }

  .operating-block {
    margin-top: 10px;
    margin-bottom: 10px;
    // width: 416px;
    // height: 48px;
    // background: #f5f5f5;
    padding: 10px 0;
    border-bottom: 1px solid #f1f1f1;
  }

  .remake {
    margin-bottom: 16px;
    color: #666;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
  }

  .check-box {
    .check-item {
      margin-top: 8px;
      margin-right: 8px;
      margin-bottom: 8px;
      padding: 8px 20px;
      border-radius: 3px;
      background: #f6f6f6;
      color: #000;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      cursor: pointer;

      &.active {
        background: rgb(116 114 246 / 10%);
        // border: 1px solid #222222;
        color: #7472f6;
      }
    }
  }
</style>
